export default __webpack_public_path__ + "assets/af7edff217e24163897b4847ce568e52.png";